import { Tab } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .tab' ) )
     .forEach( tabNode => new Tab( tabNode ) )
